import React from 'react';
import { Box, Stack, Typography } from "@mui/material"
import ShowWhen from "../Others/ShowWhen"
import { FaCheckCircle } from 'react-icons/fa'


export function Section({title, children, fontSize = '20px', gap=1, ...props}) {
    return (
        <Stack direction={'column'} gap={gap} {...props} >
            <Typography sx={{ fontSize, fontWeight: 600, color: "var(--color-text)", m: 0, opacity: '0.8' }}>
                {title}
            </Typography>
            {children}
        </Stack>
    )
}


export function SectionList({title, list=[], icon, whenEmpty, renderItem, ...props}) {
    return (
        <Section title={title} {...props} >
            <ShowWhen
                when={list?.length}
                otherwise={whenEmpty}
            >
                <Stack gap={1} >
                    {
                        list.map((item, index) => (
                            <Stack key={index} flexDirection={'row'} gap={1} >
                                <Stack flexDirection={'row'} alignItems={'center'} height={'fit-content'} >
                                    <ShowWhen when={!icon} otherwise={icon} >
                                        <Box sx={{width: '8px', height: '8px', backgroundColor: 'var(--color-primary)', borderRadius: '40px', overflow: 'hidden'}} />
                                    </ShowWhen>

                                    <Typography sx={{fontSize: '14px', visibility: 'hidden', maxWidth: '0px'}} >_</Typography>
                                </Stack>
                                    {
                                        renderItem ? renderItem(item, index) : <Typography sx={{fontSize: '14px', opacity: '0.8'}} >{item}</Typography>
                                    }
                            </Stack>
                        ))
                    }
                </Stack>
            </ShowWhen>
        </Section>
    )
}


export function SectionActiveRow({isActive=false, setIsActive, children, text}) {
    const RGB = isActive ? '100,140,255' : '200,200,200'
    return (
        <div onClick={_ => setIsActive && setIsActive(!isActive)} > 
            <Stack sx={{flexDirection: 'row', gap: '8px', padding: '12px', borderRadius: '4px', border: `2px solid rgb(${RGB},0.8)`, 
                backgroundColor: isActive ? `rgba(${RGB},0.1)` : 'transparent',
                cursor: setIsActive ? 'pointer' : 'auto'
            }} >
                <Stack flexDirection={'row'} alignItems={'center'} height={'fit-content'} >
                    <ShowWhen when={!isActive} otherwise={<FaCheckCircle style={{color: `rgb(${RGB})`, fontSize: '18px'}} />} >
                        <Box sx={{width: '18px', height: '18px', borderRadius: '40px', backgroundColor: `rgba(${RGB},0.2)`, border: `2px solid rgb(${RGB})`, flexShrink: 0}} />
                    </ShowWhen>
                    <Typography sx={{fontSize: '14px', visibility: 'hidden', maxWidth: '0px'}} >_</Typography>
                </Stack>

                <ShowWhen when={text} >
                    <Typography sx={{fontSize: '14px', opacity: '0.8'}} >{text}</Typography>
                </ShowWhen>
                
                {children}
            </Stack>
        </div>
    )
}